import React, { Fragment} from 'react';
import classnames from 'classnames';

import styles from './ButtonsUsage.css';

const ButtonsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row">
        <div className="left">
          <h1 className="h1 page-title">
            Buttons express what action will occur when the user clicks or touches it. They are use to initialize an action.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Primary Action understand the importance of the action that users should take, how frequently they interact with these buttons, and how they do it: through keyboard or mouse.</p>
          <p>In cases where the action is particularly dangerous, e.g., modal, you want users to explicitly select the button rather than accidentally activating it by hitting Enter, so make the button on the right the safest action. The safest action is the one that will allow users to maintain the system’s current state.</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row last">
        <div className="right">
          <div className={classnames(styles.buttons, 'flex flex-justify-center')}>
            <div className={styles.buttonsImage}></div>
          </div>
          <p>Primary Action understand the importance of the action that users should take, how frequently they interact with these buttons, and how they do it: through keyboard or mouse.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default ButtonsUsage;



// WEBPACK FOOTER //
// ./src/containers/elements/Buttons/ButtonsUsage/ButtonsUsage.js